import { BillOfMaterialsTemplateFlowStatus } from "@redotech/crdb-enums/inventory/bill-of-materials-template-flow-status";
import { billOfMaterialsTemplateBindingIdFormat } from "@redotech/redo-fulfillment-id";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import {
  BomTemplatePreviewConflict,
  BomTemplatePreviewRow,
} from "./bom-template-types";

export const previewBomTemplateBinding = {
  name: "previewBomTemplateBinding" as const,
  input: z.object({ bindingId: billOfMaterialsTemplateBindingIdFormat.schema }),
  output: z.object({
    rows: z.array(BomTemplatePreviewRow),
    ladderFacet: z.string().nullable(),
    flows: z.array(
      z.object({
        flowKey: z.string(),
        status: createEnum(BillOfMaterialsTemplateFlowStatus).nullable(),
        autoDecided: z.boolean(),
      }),
    ),
    coverageProblems: z.array(z.string()),
    conflicts: z.array(BomTemplatePreviewConflict),
    summary: z.object({
      ready: z.number().int(),
      draft: z.number().int(),
      skipped: z.number().int(),
      conflict: z.number().int(),
    }),
  }),
};
